<template>
    <div>
        <div class="c-section">
            <p class="my-0">Trip itinerary</p>

            <div class="o-bk-plan bg-white text-center box-sh">
                <div class="o-bk-plan__top">
                    <div>
                        <strong class="c-ttl--mdp">{{departure.format('HH:mm')}}</strong>
                        <p class="mb-0 mt-2 cl-dark">{{origin.name}}</p>
                    </div>

                    <div class="px-4">
                        <div class="c-ttl--mdp">
                            <img :src="shipArrowImage" alt="" width="120">
                        </div>

                        <p class="mb-0 mt-2 cl-dark">
                            {{duration}}
                        </p>
                    </div>

                    <div>
                        <strong class="c-ttl--mdp">{{arrival.format('HH:mm')}}</strong>
                        <p class="mb-0 mt-2 cl-dark">{{destination.name}}</p>
                    </div>
                </div>

                <div class="o-bk-plan__bottom cl-dark">
                    <span class="icon-bike mr-2 cl-white is-rounded fs-14 flex-middle wh-20" :class="[
                        hasBikeSpaceAvailable(offer) ? 'bg-green' : 'bg-red',
                    ]"></span>
                    {{ bikeAvailabilityMessage(offer) }}
                </div>
            </div>
        </div>
        
        <div class="c-section" v-if="offer.quotes.length">
            <div class="d-flex align-items-center justify-content-between">
                <span class="d-flex align-items-center">
                    <span class="icon-boat-filled fs-24 cl-sec-l mr-2"></span>
                    Select a ticket
                </span>

                <span>
                    Price per leg
                </span>
            </div>

            <div class="o-bk-ticket-list" :class="{
                'ticket-selected': isTripSelected(offer.id)
                }">
                <div
                    v-for="(quote, index) in offer.quotes"
                    v-bind:key="index"
                    class="o-bk-ticket"
                    :class="{
                        'is-vip': quote.class == 'VIP',
                        'is-selected': isOfferSelected(quote.class, quote.special_offer) 
                    }"
                    @click="onTicketSelect(offer, quote.class, quote.special_offer)">
                    <span class="o-bk-ticket__check icon-check"></span>
                    
                    <div class="o-bk-ticket__shadow">
                        <div></div>
                        <div></div>
                    </div>

                    <div class="o-bk-ticket__inner is-rounded bg-white">
                        <div class="o-bk-ticket__body">
                            <div class="o-bk-ticket__body-row">
                                <div class="d-flex align-items-center">
                                    <strong class="is-ticket-type mr-3 txt-upper">
                                        {{
                                            quote.class == 'VIP' ? 'VIP Class' : 'Standard'
                                        }}
                                    </strong>

                                    <span class="icon-person fs-12"></span>&nbsp;x {{totalPassengers}}
                                </div>

                                <!--div>
                                    <strong class="mr-2"
                                        :class="{
                                            'cl-green': quote.refundable,
                                            'cl-red': !quote.refundable
                                        }"
                                    >
                                    {{
                                        quote.refundable ? 'Refundable' : 'Non refundable'
                                    }}
                                    </strong>
                                    <span class="icon-questionmark-filled"></span>
                                </div-->
                            </div>

                            <div class="o-bk-ticket__body-row">
                                <div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.class=='STD'">
                                        <span class="icon-airline-seat is-square-icon is-rounded"></span>
                                        Standard seat in Economy Class
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.class=='VIP'">
                                        <span class="icon-airline-seat is-square-icon is-rounded"></span>
                                        Comfortable seat in VIP Class
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.class=='VIP'">
                                        <span class="icon-star is-square-icon is-rounded"></span>
                                        Priority disembarkation
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.luggage.free > 0">
                                        <span class="icon-luggage is-square-icon is-rounded"></span>
                                        {{quote.luggage.free}} check-in luggage included
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.class=='VIP'">
                                        <span class="icon-bar is-square-icon is-rounded"></span>
                                        Complimentary beverage
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2" v-if="quote.class=='VIP'">
                                        <span class="icon-eye is-square-icon is-rounded"></span>
                                        Panoramic view
                                    </div>
                                    <div class="d-flex align-items-center cl-dark mb-2">
                                        <span class="icon-info is-square-icon is-rounded px-1"></span>
                                        <span>All bookings are subject to cancellation fees as per <a href="javascript:void(0)" @click="showInfo('terms')">terms and conditions</a></span>
                                    </div>
                                </div>

                                <div>
                                    <p class="m-0 cl-dark lh-def">
                                        All prices quoted do not include Venice City Tax.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="o-bk-ticket__price">
                            <span class="is-strike cl-dark" v-if="quote.special_offer">
                                {{ currency(getRegularPrice(offer, quote.class)) }}
                            </span>
                            <strong class="is-price c-ttl--mdp d-block">
                                {{ currency(quote.total) }}
                            </strong>
                            <strong class="c-price is-rounded fs-14" v-if="quote.special_offer">
                                {{ quote.special_offer.title }}
                            </strong>
                            <div v-if="!quote.refundable" class="mt-2 cl-red">
                                <strong>Non refundable</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
    props: {
        leg: String,
        offer: Object,
    },
    data() {
        return {
            shipArrowImage: window.venezialines.theme_root+'/assets/media/icons/bk-ship-arrow.svg'
        }
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'passengersCount',
            'specialOffer',
            'accommodationClass',
        ]),
        ...mapGetters([
            'getPortById'
        ]),
        origin() {
            return this.getPortById(this.legs[this.leg].origin)
        },
        destination() {
            return this.getPortById(this.legs[this.leg].destination)
        },
        departure() {
            return moment(this.offer.itinerary.find(leg => leg.origin_id == this.origin.id).departure)
        },
        arrival() {
            return moment(this.offer.itinerary.find(leg => leg.destination_id == this.destination.id).arrival)
        },
        duration() {
            let duration = moment.duration(this.arrival.diff(this.departure))
            let hours = parseInt(duration.asHours())
            let minutes = duration.asMinutes()%60
            return hours+'h '+minutes+'m'
        },
        totalPassengers() {
            return Object.values(this.passengersCount).reduce((a, b) => a + b, 0)
        },
    },
    methods: {
        showInfo(section) {
            this.$emit('showInfo', section)
        },
        ...mapActions('booking', [
            'getQuote',
        ]),
        ...mapMutations('booking', [
            'setTrip',
        ]),
        getRegularPrice(offer, accommodationClass) {
            let quote = offer.quotes.find(quote => accommodationClass == quote.class && !quote.special_offer)
            return quote ? quote.total.toString().replace('.00', '') : ''
        },
        onTicketSelect(offer, accommodationClass, specialOffer) {
            this.setTrip({
                trip: offer,
                accommodationClass: accommodationClass,
                specialOffer: specialOffer,
                leg: this.leg
            })
            this.track({
                event: 'select_ticket',
                seat_class: accommodationClass,
                special_offer: specialOffer,
                direction: this.leg
            })
            //this.getQuote()
        },
        isTripSelected(id) {
            let trip = this.legs[this.leg].trip
            if (!trip) return false
            return trip.id == id
        },
        isOfferSelected(accommodationClass, specialOffer) {
            return (this.specialOffer == specialOffer && accommodationClass == this.accommodationClass)
        },
        hasBikeSpaceAvailable(offer) {
            return offer.availability.supplements && offer.availability.supplements['BC'] > 0
        },
        bikeAvailabilityMessage(offer) {
            let message;
            
            if (this.hasBikeSpaceAvailable(offer)) {
                message = 'Bicycle space available'
                if (offer.availability.supplements['BC'] < this.totalPassengers) {
                    message += ' (only '+offer.availability.supplements['BC']+' left)'
                }
            } else {
                message = 'No bicycle space available'
            }

            return message
        }
    }
}
</script>